// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3FWB3","loaderOuter":"PageOverlayLoader_loaderOuter__2-QCb"};